import script from "./ViewCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCounter.vue?vue&type=script&setup=true&lang=js"

import "./ViewCounter.vue?vue&type=style&index=0&id=1ae7f600&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae7f600"]])

export default __exports__